import { ISessionStateData } from "core/redux/features/session/sessionSliceInterfaces";
import { EnumDictionary } from "types/EnumDictionary";
import { PagesEnum } from "types/PagesEnum";
import { formStep } from "types/StepEnums";

const pagesDictionaryFromEnum: EnumDictionary<PagesEnum, string> = {
	[PagesEnum.ReservationForm]: "Reservation",
	[PagesEnum.PersonalArea]: "ReservedArea",
	[PagesEnum.ChangePassword]: "ChangePassword",
	[PagesEnum.Login]: "Login",
	[PagesEnum.Payment]: "Payment",
	[PagesEnum.PrivacyPolicy]: "PrivacyPolicy",
	[PagesEnum.Notification]: "Notification",
	[PagesEnum.Help]: "Help",
};

const pagesEnumFromPageName: EnumDictionary<string, PagesEnum> = {
	Reservation: PagesEnum.ReservationForm,
	ReservedArea: PagesEnum.PersonalArea,
	ChangePassword: PagesEnum.ChangePassword,
	Login: PagesEnum.Login,
	Payment: PagesEnum.Payment,
	PrivacyPolicy: PagesEnum.PrivacyPolicy,
	Help: PagesEnum.Help,
};

const getCurrentPageName = (pagePath: string) => {
	let page: string = pagePath;
	if (pagePath.startsWith("/")) {
		page = pagePath.slice(1);
	}
	page = page.split("?")[0].split("/")[0];
	return page;
};

export const terminateSession=(GoToPage:Function,OnFinishSession:Function,sessionInfo:ISessionStateData)=>{
	OnFinishSession(sessionInfo.step as number, false)
	setTimeout(() => {
		const loadingBlock = document.getElementById("loading");
		if (loadingBlock) loadingBlock.style.display = "none";
		GoToPage(PagesEnum.ReservationForm, formStep.Home, { backNavAllowed: true, reset: true });
	}, 2000);
}


export { pagesDictionaryFromEnum, pagesEnumFromPageName, getCurrentPageName };
